// @ts-check
import { Cell, Pie, PieChart } from 'recharts';
import BlockCard from '../BlockCard';

// Keyed by status name (backend TaskStatus) so a colour never shifts when another status is absent.
const COLORS = { to_do: '#64748b', in_progress: '#3b82f6', review: '#f59e0b', done: '#22c55e', blocked: '#ef4444' };
const FALLBACK_COLOR = '#94a3b8';

/** Task status donut (status names come from the API) with the number due today. */
export default function TasksBlock({ block }) {
  const { by_status: byStatus = {}, due_today: dueToday = 0 } = block.data || {};
  const slices = Object.entries(byStatus).map(([name, value]) => ({ name: name.replace(/_/g, ' '), value, fill: COLORS[name] || FALLBACK_COLOR }));

  return (
    <BlockCard title="Tasks" href={block.href} headline={block.headline}>
      {slices.length > 0 ? (
        <div data-testid="tasks-chart" className="flex items-center gap-4 overflow-x-auto">
          <PieChart width={110} height={110} aria-hidden="true">
            <Pie data={slices} dataKey="value" nameKey="name" innerRadius={30} outerRadius={50} isAnimationActive={false}>
              {slices.map((s) => (
                <Cell key={s.name} fill={s.fill} />
              ))}
            </Pie>
          </PieChart>
          <ul data-testid="tasks-legend" className="text-sm text-muted-foreground">
            {slices.map((s) => (
              <li key={s.name}>
                <span className="mr-2 inline-block h-2 w-2 rounded-full" style={{ backgroundColor: s.fill }} />
                {`${s.name} ${s.value}`}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No tasks yet</p>
      )}
      <p className="mt-2 text-sm text-muted-foreground" data-testid="tasks-due-today">
        {dueToday} due today
      </p>
    </BlockCard>
  );
}
